import { render, staticRenderFns } from "./publicacion.vue?vue&type=template&id=b043532a&scoped=true&"
import script from "./publicacion.vue?vue&type=script&lang=ts&"
export * from "./publicacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043532a",
  null
  
)

export default component.exports